RivalIQ.module('admin', function (admin, App, Backbone, Marionette, $, _) {

    'use strict';

    /**
     * Enforces function invocation eligibility given admin status.
     * @param fn
     * @param [scope]
     */
    function enforce(fn, scope) {

        return function () {

            const args = arguments;

            if (!App.state.account.isAdmin()) {

                return App.logger.warn('attempt to execute admin command by user');
            }

            return fn.apply(scope, args);
        };
    }

    /**
     * Updates external data by landscape.
     * @param landscapeId
     */
    const updateExternalDataByLandscape = enforce(function (landscapeId) {

        return $.get(`/admin/updateAllExternalDataByLandscapeId/${landscapeId}/true`);
    });

    App.commands.setHandler('admin:landscape:update', function (landscapeId) {

        landscapeId = (landscapeId || App.state.view.get('landscapeId'));
        App.logger.info(`updating all external data for landscape ${landscapeId}`);
        updateExternalDataByLandscape(landscapeId);
    });

    /*
     * Exports everything on the current page using the current branding
     **/
    App.commands.setHandler('admin:export:all', function () {
        const account = RivalIQ.state.account;
        account.set('skipBrandingModal', true);

        $('a[data-format]').each(function (i, link) {
            $(link).click();
        });
    });

    /**
     * Dismisses or undismisses a widget by id for the current landscape.
     * @param id
     * @param [dismiss]
     */
    App.commands.setHandler('admin:widget:dismiss', function (id, dismiss) {

        const widgets = App.state.landscape.get('widgets');

        const settings = _.get(widgets, id, {});
        settings.dismissed = Boolean(dismiss);
        settings.available = !settings.dismissed;
        widgets[id] = settings;

        App.logger.info(`updating dismissal state of widget ${id} to ${Boolean(dismiss)}`);

        App.state.landscape.set({
            widgets: widgets
        });
    });

    function createMarkdownLine(name, value) {
        return [['**', name, '**'].join(''), value].join(': ');
    }

    admin.getBugState = function () {
        const fields = [
            {
                name: 'Email',
                state: RivalIQ.state.user,
                property: 'email'
            },
            {
                name: 'URL',
                state: window.location,
                property: 'href'
            },
            {
                name: 'User Agent',
                state: navigator,
                property: 'userAgent'
            },
            {
                name: 'Resolution',
                state: window,
                serializer: function (window) {
                    return `${window.innerWidth}x${window.innerHeight}`;
                }
            },
            {
                name: 'Landscape',
                state: RivalIQ.state.view,
                property: 'landscapeName'
            },
            {
                name: 'Company Set',
                state: RivalIQ.state.view,
                property: 'companySetDescriptor',
                serializer: function (companySetDescriptor) {
                    return `${RivalIQ.state.utils.getCompanySetName(companySetDescriptor)} (id: ${companySetDescriptor})`;
                }
            },
            {
                name: 'Time Period',
                state: RivalIQ.state.view,
                property: 'timePeriod',
                serializer: function (val) {
                    return _.get(val, 'displayString');
                }
            },
            {
                name: 'Timezone',
                state: RivalIQ.state.landscape,
                property: 'timezone'
            },
            {
                name: 'Landscape ID',
                state: RivalIQ.state.landscape,
                property: 'id'
            },
            {
                name: 'User ID',
                state: RivalIQ.state.user,
                property: 'id'
            },
            {
                name: 'Account ID',
                state: RivalIQ.state.account,
                property: 'id'
            },
            {
                name: 'Primary Account ID',
                state: RivalIQ.state.account,
                property: 'primaryAccountId'
            },
            {
                name: 'Beta Features',
                state: RivalIQ.state.account,
                property: 'betaFeatures',
                serializer: function (val) {
                    return JSON.stringify(val, null, 2);
                }
            },
            {
                name: 'Plan',
                state: RivalIQ.state.account,
                property: 'plan',
                serializer: function (plan) {
                    return `${plan.name} (${plan.stripe_id})`;
                }
            },
            {
                name: 'Plan Overrides',
                state: RivalIQ.state.account,
                property: 'planOverrides',
                serializer: function (val) {
                    return JSON.stringify(val, null, 2);
                }
            }
        ];

        return fields;
    };

    function mapBugState(field) {
        let value = field.state;
        const property = field.property;
        if (property) {
            if (value instanceof Backbone.Model) {
                value = value.get(property);
            } else {
                value = value[property];
            }
        }

        const serializer = (field.serializer || _.identity);
        return [field.name, serializer(value)];
    }

    admin.getBugStateMarkdown = function () {
        const fields = admin.getBugState();

        const markdown = _.map(fields, function (field) {
            const [name, value] = mapBugState(field);
            return createMarkdownLine(name, value);
        }).join('\n');

        return markdown;
    };

    App.commands.setHandler('admin:bug:state', function () {
        console.log(admin.getBugStateMarkdown());
    });

});
